import { axiosInstance } from './instance';

export interface SearchRoutesOutput {
  routes: any[];
  total?: number;
}

export async function searchRoutes(
  query: string,
  offset: number = 0,
  limit: number = 10
): Promise<SearchRoutesOutput> {
  const response = await axiosInstance.get('/routes/search', {
    params: { query, offset, limit }
  });
  return response.data;
}
